import { post } from '../service/request'

/**
 * 获取项目招商房源信息列表
 * @param {*} page
 * @param {*} limit
 * @returns
 */
export const getHouseList = (page = 1, limit = 10) => {
	const params = {
		page,
		limit,
	}
	return post('/houseInfo/list', params)
}

/**
 * 获取房源信息详情
 * @param {*} id
 * @returns
 */
export const getHouseDetail = (id) => {
	return post('/houseInfo/getDetail', { id })
}

export const getBusinessList = (page = 1, limit = 10) => {
	const params = {
		page,
		limit,
	}
	return post('purchaseBusiness/list', params)
}

/**
 * 获取采购招商详情
 * @param {*} id
 * @returns
 */
export const getBusinessDetail = (id) => {
	return post('/purchaseBusiness/getDetail', { id })
}
